import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService, LoadingService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { CategoriaService } from '../../categoria/categoria.service';
import { ProductoService } from '../producto.service';
import { CategoriaCreateComponent } from '../../categoria/categoria-create/categoria-create.component';

@Component({
  selector: 'app-producto-create',
  templateUrl: './producto-create.component.html',
  styleUrls: ['./producto-create.component.scss']
})
export class ProductoCreateComponent implements OnInit {
  form: FormGroup = new FormGroup({});
  estado = [{ id: 1, name: 'Activo' }, { id: -1, name: 'Inactivo' }]
  moneda = [{ id: 1, name: 'CLP' }, { id: 2, name: 'USD' }, { id: 3, name: 'UF' }]
  categorias: Array<any> = []
  constructor(
    public formBuilder: FormBuilder,
    public config: ConfigService,
    public formatter: FormatterService,
    private loading: LoadingService,
    private alerts: AlertService,
    public service: ProductoService,
    public _service: CategoriaService,
    public activeModal: NgbActiveModal,
    private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.select();
    this.form = this.formBuilder.group({
      nombre: ['', [Validators.required]],
      descripcion: [],
      sku: [],
      codigo_barra: [],
      precio_venta: ['', [Validators.required]],
      precio_compra: ['', [Validators.required]],
      precio_mayorista: [],
      moneda: ['', [Validators.required]],
      stock_minimo: [],
      estado: [1, [Validators.required]],
      tipo: [1],
      categoria_id: [null],
    });
    this.form.patchValue({ moneda: 1 });
  }

  agregarCategoria(){
    const modalRef = this.modalService.open(CategoriaCreateComponent,{ size: 'lg', scrollable: true });
    modalRef.result.then((result: any) => {
      this.select(true);
    }, (reason: any) => {});
  }

  guardar(): void {
    if (this.form.valid) {
      this.loading.show();
      this.service.create(this.form.value).subscribe({
        next: (res) => {
          this.loading.hide();
          this.activeModal.close(res.model);
          this.alerts.addAlert(res.response, "success");
        },
        error: (err) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se pudo guardar el registro.", "danger");
          if (err.error.response) {
            this.alerts.addAlert(err.error.response, "danger");
          }
        }
      });
    } else {
      this.form.markAllAsTouched();
      this.alerts.addAlert("Hay errores en el formulario.", "warning");
    }
  }

  select(selectLast: boolean = false): void {
    this.loading.show();
    let user = JSON.parse(localStorage.getItem('usuario') as string);
    this._service.select(user).subscribe({
      next: (res) => {
        this.loading.hide();
        this.categorias = res;
        if(selectLast && this.categorias.length > 0) this.form.patchValue({categoria_id: this.categorias[this.categorias.length -1].id});
      },
      error: (err) => {
        console.error(err);
        this.loading.hide();
        this.alerts.addAlert("No se pudo cargar Tipos de Categorías de la empresa", "danger");
        if (err.error.response) {
          this.alerts.addAlert(err.error.response, "danger");
        }
      }
    });
  }
}
